import { render, staticRenderFns } from "./PhysicalStorageCategory.vue?vue&type=template&id=e7dc1cbc"
import script from "./PhysicalStorageCategory.vue?vue&type=script&lang=js"
export * from "./PhysicalStorageCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports